<template>
    <div>
        <el-button v-on:click="backHistory">返回</el-button>
        <div class="infoDetailBoxs">
            <div>
                <span class="spana">名    &nbsp;&nbsp;&nbsp; &nbsp;    称:</span>&nbsp;&nbsp;&nbsp;
                <el-input v-model="query.dz_name" placeholder="请输入内容" style="width:30%;"></el-input>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div>
                <span class="spana">跳&nbsp; 转&nbsp;url:</span>&nbsp;&nbsp;&nbsp;
                <el-input v-model="query.dz_url" placeholder="请输入内容" style="width:30%;"></el-input>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div>
                <span class="spana">关联Tag:</span>&nbsp;&nbsp;&nbsp;
                <el-input v-model="query.cate_name" placeholder="请输入内容" style="width:30%;"></el-input>
                <!-- <el-select v-model="query.consultation_cate_id" placeholder="请选择">
                    <el-option 
                    v-for="item in options"
                    :key="item.consultation_cate_id"
                    :label="item.cate_name"
                    :value="item.consultation_cate_id">
                    </el-option>
                </el-select> -->
            </div>
        </div>
                                <!-- action="http://tapi.inchengzi.com/upload" -->

        <div class="infoDetailBoxTwo" style="height:580px;">
            <div style="width:93px;">
                <span >上传视屏：</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div class="pic_img" style="">
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess1"
                            v-bind:on-success="handleVideoSuccess1"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath1 !='' && !videoFlag"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath1"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath =='' && !videoFlag"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent1"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">480*800</span>
                </div>
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess2"
                            v-bind:on-success="handleVideoSuccess2"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath2 !='' && !videoFlag2"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath2"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath2 =='' && !videoFlag2"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag2 == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">640*960</span>
                </div>
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess3"
                            v-bind:on-success="handleVideoSuccess3"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath3 !='' && !videoFlag3"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath3"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath3 =='' && !videoFlag3"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag3 == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">640*1136</span>
                </div>
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess4"
                            v-bind:on-success="handleVideoSuccess4"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath4 !='' && !videoFlag4"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath4"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath4 =='' && !videoFlag4"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag4 == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">720*1280</span>
                </div>
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess5"
                            v-bind:on-success="handleVideoSuccess5"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath5 !='' && !videoFlag5"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath5"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath5 =='' && !videoFlag5"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag5 == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">750*1624</span>
                </div>
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess6"
                            v-bind:on-success="handleVideoSuccess6"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath6 !='' && !videoFlag6"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath6"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath6 =='' && !videoFlag6"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag6 == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent6"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">1080*1920</span>
                </div>
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                            :action= uploadUrl
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            v-bind:on-progress="uploadVideoProcess7"
                            v-bind:on-success="handleVideoSuccess7"
                            v-bind:before-upload="beforeUploadVideo"
                            v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath7 !='' && !videoFlag7"
                            style="width:100%;height:100%;margin-right:0"
                            v-bind:src="videoForm.showVideoPath7"
                            class="avatar video-avatar"
                            controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath7 =='' && !videoFlag7"
                        class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag7 == true"
                                    type="circle"
                                    v-bind:percentage="videoUploadPercent7"
                                    style="margin-top:7px;"></el-progress>
                    </el-upload>
                    <span class="upload_text">1080*1240</span>
                </div>
            </div>
        </div>
        
    
        <el-row class="button-row">
            <el-button type="success" round style="margin-right:10px;" @click.native="onSubmit()">保存</el-button>
            <el-button type="info" round v-on:click="backHistory">返回</el-button>
        </el-row>
    </div>
</template>

<script>
import { BASE_URL } from "../../config/app";
import Tinymce from "../../components/Tinymce/index.vue";
import { openScreen, dzTagDetail, openScreenUpd } from "../../api/category/category";
import {
    quillRedefine
} from 'vue-quill-editor-upload' //引入图片上传
export default {
    data() {
        return {
            // uploadUrl: "http://tapi.inchengzi.com/upload",
            uploadUrl: BASE_URL+"/admin/app/Users/getUpload",
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            editorOption: {}, //富文本编辑器配置文件上传路径
            query: {
                cate_name : '',
                dz_name : '',
                dz_url: '',
                dz_video : '',
                dz_video2 : '',
                dz_video3 : '',
                dz_video4 : '',
                dz_video5 : '',
                dz_video6 : '',
                dz_video7 : '',
                cate_id: 0,
            },
            formData:{
                img:'',
            },
            list: [],
            options: [],
            value: '',
            videoFlag: false,
            videoFlag2: false,
            videoFlag3: false,
            videoFlag4: false,
            videoFlag5: false,
            videoFlag6: false,
            videoFlag7: false,
            //是否显示进度条
            videoUploadPercent1: "",
            videoUploadPercent2: "",
            videoUploadPercent3: "",
            videoUploadPercent4: "",
            videoUploadPercent5: "",
            videoUploadPercent6: "",
            videoUploadPercent7: "",
            //进度条的进度，
            isShowUploadVideo1: false,
            isShowUploadVideo2: false,
            isShowUploadVideo3: false,
            isShowUploadVideo4: false,
            isShowUploadVideo5: false,
            isShowUploadVideo6: false,
            isShowUploadVideo7: false,
            //显示上传按钮
            videoForm: {
                showVideoPath1: '',
                showVideoPath2: '',
                showVideoPath3: '',
                showVideoPath4: '',
                showVideoPath5: '',
                showVideoPath6: '',
                showVideoPath7: '',
            },
            columnName: localStorage.getItem('columnName'),
        }
    },
    methods: {
	    //上传前回调
        beforeUploadVideo(file) {
            var fileSize = file.size / 1024 / 1024 < 50;
            if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
                layer.msg("请上传正确的视频格式");
                return false;
            }
            if (!fileSize) {
                layer.msg("视频大小不能超过50MB");
                return false;
            }
            this.isShowUploadVideo = false;
        },
        //进度条
        uploadVideoProcess1(event, file, fileList) {
            this.videoFlag = true;
            this.videoUploadPercent1 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent1,'this.videoUploadPercent'); // 进度条
        },
        uploadVideoProcess2(event, file, fileList) {
            this.videoFlag2 = true;
            this.videoUploadPercent2 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent2,'this.videoUploadPercent'); // 进度条
        },
        uploadVideoProcess3(event, file, fileList) {
            this.videoFlag3 = true;
            this.videoUploadPercent3 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent3,'this.videoUploadPercent'); // 进度条
        },
        uploadVideoProcess4(event, file, fileList) {
            this.videoFlag4 = true;
            this.videoUploadPercent4 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent4,'this.videoUploadPercent'); // 进度条
        },
        uploadVideoProcess5(event, file, fileList) {
            this.videoFlag5 = true;
            this.videoUploadPercent5 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent5,'this.videoUploadPercent'); // 进度条
        },
        uploadVideoProcess6(event, file, fileList) {
            this.videoFlag6 = true;
            this.videoUploadPercent6 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent6,'this.videoUploadPercent'); // 进度条
        },
        uploadVideoProcess7(event, file, fileList) {
            this.videoFlag7 = true;
            this.videoUploadPercent7 = file.percentage.toFixed(0) * 1;
            // console.log(this.videoUploadPercent7,'this.videoUploadPercent'); // 进度条
        },
        //上传成功回调
        handleVideoSuccess1(res, file) {
            // console.log(res,'res--上传视频--11')
            this.isShowUploadVideo = true;
            this.videoFlag = false;
            this.videoUploadPercent1 = 0;

            if (res.code == 0) {
                if (res.data.width != 480 || res.data.height != 800) {
                    this.$message.error('请上传尺寸为480*800的视频~');
                } else {
                    this.videoForm.showVideoPath1 = res.data.video;
                    // console.log(this.videoForm.showVideoPath1 ,'111111111111')
                }
            } else {
                layer.msg(res.Message);
            }
        },
        handleVideoSuccess2(res, file) {
            this.isShowUploadVideo2 = true;
            this.videoFlag2 = false;
            this.videoUploadPercent2 = 0;
            if (res.code == 0) {
                if (res.data.width != 640 || res.data.height != 960) {
                    this.$message.error('请上传尺寸为640*960的视频~');
                } else {
                    this.videoForm.showVideoPath2 = res.data.video;
                    //  console.log(this.videoForm.showVideoPath2 ,'222222222222222')
                }
            } else {
                layer.msg(res.Message);
            }
            // if (res.code == 0) {
            //     this.videoForm.showVideoPath2 = res.data;
            //     console.log(this.videoForm,'his.videoForm.showVideoPath22222222222222')
            // } else {
            //     layer.msg(res.Message);
            // }
        },
        handleVideoSuccess3(res, file) {
            this.isShowUploadVideo3 = true;
            this.videoFlag3 = false;
            this.videoUploadPercent3 = 0;
            if (res.code == 0) {
                if (res.data.width != 640 || res.data.height != 1136) {
                    this.$message.error('请上传尺寸为640*1136的视频~');
                } else {
                    this.videoForm.showVideoPath3 = res.data.video;
                }
            } else {
                layer.msg(res.Message);
            }
        },
        handleVideoSuccess4(res, file) {
            this.isShowUploadVideo4 = true;
            this.videoFlag4 = false;
            this.videoUploadPercent4 = 0;
            if (res.code == 0) {
                this.videoForm.showVideoPath4 = res.data;
                // console.log(this.videoForm,'his.videoForm.showVideoPath4444444444')
            } else {
                layer.msg(res.Message);
            }
            if (res.code == 0) {
                if (res.data.width != 720 || res.data.height != 1280) {
                    this.$message.error('请上传尺寸为720*1280的视频~');
                } else {
                    this.videoForm.showVideoPath4 = res.data.video;
                }
            } else {
                layer.msg(res.Message);
            }
        },
        handleVideoSuccess5(res, file) {
            this.isShowUploadVideo5 = true;
            this.videoFlag5 = false;
            this.videoUploadPercent5 = 0;
            if (res.code == 0) {
                if (res.data.width != 750 || res.data.height != 1624) {
                    this.$message.error('请上传尺寸为750*1624的视频~');
                } else {
                    this.videoForm.showVideoPath5 = res.data.video;
                }
            } else {
                layer.msg(res.Message);
            }
        },
        handleVideoSuccess6(res, file) {
            this.isShowUploadVideo6 = true;
            this.videoFlag6 = false;
            this.videoUploadPercent6 = 0;
            if (res.code == 0) {
                if (res.data.width != 1080 || res.data.height != 1920) {
                    this.$message.error('请上传尺寸为1080*1920的视频~');
                } else {
                    this.videoForm.showVideoPath6 = res.data.video;
                }
            } else {
                layer.msg(res.Message);
            }
        },
        handleVideoSuccess7(res, file) {
            this.isShowUploadVideo7 = true;
            this.videoFlag7 = false;
            this.videoUploadPercent7 = 0;
            if (res.code == 0) {
                if (res.data.width != 1080 || res.data.height != 1240) {
                    this.$message.error('请上传尺寸为1080*1240的视频~');
                } else {
                    this.videoForm.showVideoPath7 = res.data.video;
                }
            } else {
                layer.msg(res.Message);
            }
        },

        // 旧
        handleAvatarSuccess(res, file) {
            this.query.image = BASE_URL+'/'+res.data;
            this.imageUrl = res.data
            this.formData.img = res.data;
        },
        beforeAvatarUpload(file) {
            let _this = this
            let file_type = file.type.substr( 0, file.type.indexOf("/"));
            if( !([ "image"]).includes( file_type)){
                this.$message.error( "只能上传图片");
                return false;
            }
            if( file_type == "image"){
                // const isLt2M = file.size / 1024 / 1024 < 2;
                const isSize = new Promise(function (resolve, reject) {
                    // let width = 198;
                    // let height = 198;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        // let valid = img.width == width && img.height == height;
                        let valid = true
                        valid ? resolve() : reject();
                    }
                    img.src = _URL.createObjectURL(file);
                }).then(res=>{
                    return file;
                }).catch(err=>{
                    this.$message.error('图片格式错误，请上传长198像素、宽198像素的图片');
                    return Promise.reject();
                });
                return isSize
            }
            this.uploading = true;
        },


        handleRemove(file, fileList) {
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.query.image = this.dialogImageUrl;
            this.dialogVisible = true;
        },
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        // getData() {
        //     openScreen(this.query)
        //         .then(response => {
        //             this.loading = false;
        //             this.options = response.data.data || [];
        //         })
        //         .catch(() => {
        //             this.loading = false;
        //             this.list = [];
        //             this.total = 0;
        //         });
        // },
        getList() {
           this.loading = true;
            dzTagDetail(this.query)
                .then(response => {
                    this.loading = false;
                    this.list = response.data || [];
                    this.query = this.list;
                    this.query.cate_id = this.list.cate_id;
                    this.query.cate_name = this.list.cate_name;
                    this.query.dz_name = this.list.dz_name;
                    this.query.dz_url = this.list.dz_url;
                    this.query.dz_video = this.list.dz_video;
                    this.videoForm.showVideoPath1 = this.list.dz_video;
                    this.videoForm.showVideoPath2 = this.list.dz_video2;
                    this.videoForm.showVideoPath3 = this.list.dz_video3;
                    this.videoForm.showVideoPath4 = this.list.dz_video4;
                    this.videoForm.showVideoPath5 = this.list.dz_video5;
                    this.videoForm.showVideoPath6 = this.list.dz_video6;
                    this.videoForm.showVideoPath7 = this.list.dz_video7;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        // 保存按钮
        onSubmit() {
            this.query.dz_video = this.videoForm.showVideoPath1
            this.query.dz_video2 = this.videoForm.showVideoPath2
            this.query.dz_video3 = this.videoForm.showVideoPath3
            this.query.dz_video4 = this.videoForm.showVideoPath4
            this.query.dz_video5 = this.videoForm.showVideoPath5
            this.query.dz_video6 = this.videoForm.showVideoPath6
            this.query.dz_video7 = this.videoForm.showVideoPath7
            // console.log(this.query,'this.query')

            this.loading = true;
            if (this.query.cate_id == 0) {
                openScreen(this.query)
                .then(response => {
                    if (response.code == 0) {
                        // alert('添加成功！')
                        this.$message({
                            message: '添加成功！',
                            type: 'success'
                        });
                        this.$router.push({ path: `/openScreen/openScreen` })
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
            } else {
                openScreenUpd(this.query)
                .then(response => {
                    if (response.code == 0) {
                        alert('修改成功！')
                        this.$router.push({ path: `/openScreen/openScreen` })
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
            }
        },
    },
    components: {
        Tinymce
    },
    computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
            proStatus() { //上传状态
                if (this.pass) {
                    return 'success'
                } else if (this.pass === false) {
                    return 'exception'
                } else {
                    return 'success'
                }
            },
        },
    created() {
        // 将参数拷贝进查询对象
        this.query.cate_id = this.$route.params.cate_id ?  this.$route.params.cate_id : 0 ;
        // console.log(this.query.cate_id,'this.query.cate_id0000000000000000')
        if (this.query.cate_id != 0) {
            this.getList();
        } else {
            this.query.cate_name = '';
            this.query.dz_name = '';
            this.query.dz_video = '';
            this.query.dz_url = '';
            this.videoForm.showVideoPath = '';
            this.videoForm.showVideoPath2 = '';
            this.videoForm.showVideoPath3 = '';
            this.videoForm.showVideoPath4 = '';
            this.videoForm.showVideoPath5 = '';
            this.videoForm.showVideoPath6 = '';
            this.videoForm.showVideoPath7 = '';
        }

        // this.editorOption = quillRedefine( //修改富文本编辑器图片上传路径
        // {
        //     // 图片上传的设置
        //     uploadConfig: {
        //         action: this.uploadUrl, // 必填参数 图片上传地址
        //         res: (respnse) => {
        //             return respnse.data; //return图片url
        //         },
        //         name: 'file' // 图片上传参数名
        //     }
        // })
    },
    filters: {
        //时间转换 用到moment.js
        formatDate: function(value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        findTypeLabel(status) {
            const statusMap = {
                1: "患儿故事",
                2: "患儿视频",
                3: "学术动态",
            };
            return statusMap[status];
        }
    }
};
</script>

<style type="text/scss" lang="scss">
.spana {
    width: 40px;
}
div {
    font-size: 14px;
}
p {
    font-size: 14px;
}
>>>.el-row{
    margin-bottom: 12px;
}
.uploadProductDiv {
    width: 1190px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 4px;
}

.uploadProductDiv-header {
    text-align: center;
    font-size: 30px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bold;
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: #FBD7D9;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
}

.uploadProductDiv-body {
    box-sizing: border-box;
    padding-left: 115px;
    padding-top: 65px;
}

.uploadProductDiv-inputDiv {
    display: flex;
    margin-bottom: 20px;
    position: relative;
}

.uploadProduct-Pname {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    height: 40px;
    width: 140px;
}
.form-input{
    width: 440px;
}
.uploadProduct-input {
    box-sizing: border-box;
    width: 440px;
    height: 40px;
    line-height: 40px;
    background: #F3F0F0;
    border: 1px solid #DEDEDE;
    border-radius: 4px;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    padding-left: 20px;
    outline: none;
    margin-left: 46px;
    position: absolute;
    left: 62px;
}
.uploadProduct-pyuan {
    position: absolute;
    left: 565px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    height: 40px;
}
.avatar-uploader {
    width: 100% !important;
    height: 100% !important;
}
.avatar-uploader .el-upload {
    width: 100% !important;
    height: 100% !important;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100% !important;
    height: 100% !important;
    line-height: 210px !important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.button-row {
    margin-top: 20px;
    margin-left: 12%;
}
.inputs {
    border: #757779 1px solid;
    height: 40px;
    margin-left: 20px;
    width: 122px;
}
.infoDetailBoxTwo {
    height: 190px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid  #dddddd;
    position: relative;
    div {
        width: 80%;
    }
}
.infoDetailBoxs {
    height: 80px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid  #dddddd;
    position: relative;
    div {
        width: 56%;
    }
}
.infoDetailBoxContent {
    height: 480px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid  #dddddd;
    position: relative;
    div {
        width: 56%;
    }
}
.gcDetails {
    box-sizing: border-box;
    padding: 15px 50px;
    border-bottom: 1px solid #dddddd;
    > div {
        display: flex;
    }
}
.gcDetails > div > :nth-child(2) {
    margin-left: 50px;
}
.chakandetail {
    color: #2490fa;
    cursor: pointer;
    margin-left: 10px;
}
.jlSpan {
    margin-left: 35px;
}
.imgsDiv {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    width: 525px;
    img {
        margin-right: 10px;
        margin-bottom: 10px;
    }
}
.pic_img {
    width: 920px !important;
}
.pic_img_box {
    float: left;
    width: 210px !important;
    height: 210px !important;
    margin-right: 20px !important;
    margin-bottom: 60px !important;
}
.upload_text {
    width: 210px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    display: block;
}
</style>
